/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * weather
 */

import $ from 'jquery';

const weather = {
    cfg: {
        wrapper: document.querySelectorAll('.js-weather'),
        language: 'de',
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.wrapper) {
                this.cfg.language = this.cfg.wrapper[0].dataset.lang;
                /* eslint-disable */
                $.getJSON('https://api.openweathermap.org/data/2.5/weather?q=Grundlsee&units=metric&APPID=2b040945d83db0fab0a8c74fada32f46&lang=' + this.cfg.language, (data) => {
                    // this.cfg.wrapper.innerHTML += JSON.stringify(data);

                    this.cfg.wrapper.forEach((wrapper) => {
                        // Manipulate Current Temperature
                        wrapper.querySelector('.js-currentTemp').innerHTML = `${Math.round(data.main.temp*2)/2}&deg;`.replace('.', ',');

                        // Manipulate Icon
                        wrapper.querySelector('.js-currentIcon').innerHTML = `
                          <svg class="a-svgSprite" viewbox="0 0 48 48">
                            <use xlink:href="/assets/images/svg/sprite/sprite.svg#${data.weather[0].id}"></use>
                          </svg>`;
                    });

                });
                // Get Wassertemperatur
                $.getJSON('/weather/latest_temperature.json', (data) => {
                    this.cfg.wrapper.forEach((wrapper) => {
                        // Manipulate Current Temperature
                        wrapper.querySelector('.js-currentWaterTemp').innerHTML = `${Math.round(data.water*10)/10}&deg;`.replace('.', ',');
                    });
                });
                /* eslint-enable */
            }
        });
    }
};

export default weather;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/weather/_script.js